import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(private router: Router, private logger: NGXLogger) {}
  inputPassword = '';
  inputEmail = '';
  inputLdapPassword = '';
  inputLdapEmail = '';
  loginLevel: number = 0;
  loginDenied: boolean = false;
  email = 'test@apss.tn.it';
  password = '1234';
  login = false;
  fiscalCode = '';
  name = '';
  surname = '';
  sessionTimedOut = false;
  production = false;

  ngOnInit(): void {
    this.logger.info('(AUTHENTICATOR-LOGIN)ngOnInit');

    this.logger.info(
      "(AUTHENTICATOR-LOGIN) 1 - Verifico che l'Utente non abbia gia effettuato l'accesso"
    );
    if (
      sessionStorage.getItem('login') == 'true' &&
      sessionStorage.getItem('token')
    ) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 1.1 - L'utente HA GIA' effettuato l'accesso, lo reindirizzo alla home "
      );
      this.router.navigate(['/home']);
    }

    if (sessionStorage.getItem('logout') == 'true') {
      if (sessionStorage.getItem('sessionTimedOut') == 'true') {
        this.sessionTimedOut = true;
      }
      sessionStorage.clear();
    }

    if(environment.production){
      this.production = true;
    }
  }

  autenticazione(loginLevelSelected: number): void {
    if (loginLevelSelected == 3) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso SPID"
      );
      window.location.replace(environment.baseUrl + 'spid-authenticator/login');
    } else if (loginLevelSelected == 2) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso ENTRA"
      );
      sessionStorage.setItem('loginLevel', 'entra');
      window.location.replace(environment.baseUrl + 'entra-authenticator');
    } else if (loginLevelSelected == 1) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso con Email e Pasword"
      );
      sessionStorage.setItem('loginLevel', 'normal');
      this.router.navigate(['/login-form']);
    }
  }
}
